import React from 'react';
import { func, oneOf, bool, string } from 'prop-types';
import styles from './styles/styles.module.scss';

const Button = ({ variant, disabled, onClick, classes, children }) => {
  return (
    <button type="button" disabled={disabled} onClick={onClick} className={`${styles[variant]} ${classes}`} data-test-id={children}>
      {children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  onClick: func.isRequired,
  variant: oneOf(['primary', 'secondary', 'small', 'flat']).isRequired,
  disabled: bool,
  classes: string
};

Button.defaultProps = {
  disabled: false,
  classes: ''
};
